import Logo from "../components/Logo"
import Card from "../components/Card"
import Button from "../components/Button"
import { useNavigate } from "react-router-dom";
import Success from "../assets/success-gif.gif"

function PaymentSuccessful() {
  const navigate = useNavigate();

  const handlePrev = () => {
    navigate('/')
  }

  return (
    <div className="login-container">
    <Logo/>
    <Card>
    <div className="img-group">
            <img src={Success} alt="success" />
        </div>
    <h4 className="card-head success"> 
    Payment successful!
    </h4>
    <div className="banner successful-banner"></div>
    
    <p className="card-text span-group">
    Seamless right? You can also receive payments from anywhere in the world
    </p>

    <div className="err-btn-group" onClick={handlePrev}>
    <Button>
    Click here to get Started
    </Button> 
    </div>
   
    </Card>
    
</div>
  )
}

export default PaymentSuccessful
